module.exports = __webpack_public_path__ + "static/media/journey 03.77723a1d.png";